export const isDemoPath = (pathname = window.location.pathname) => (
  pathname === "/demo" || pathname.startsWith("/demo/")
);

// React Router's basename handles navigate(). These helpers cover the few
// app-relative return paths built from the browser's full pathname instead.
export const appPathname = (pathname = window.location.pathname) => (
  isDemoPath(pathname) ? pathname.slice(5) || "/" : pathname
);
export const appLocationPath = (locationLike = window.location) => (
  `${appPathname(locationLike.pathname)}${locationLike.search || ""}${locationLike.hash || ""}`
);

// Only installed inside a proven isolated demo. Router URLs already carry the
// basename; direct History writes from editors need it added exactly once.
export function demoHistoryUrl(value, base = window.location.href) {
  if (value == null) return value;
  const url = new URL(value, base);
  if (url.origin !== new URL(base).origin) throw new DOMException("External navigation is unavailable in Demo Mode.", "SecurityError");
  if (!isDemoPath(url.pathname)) url.pathname = `/demo${url.pathname}`;
  return `${url.pathname}${url.search}${url.hash}`;
}
